import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../Services/apiService";

export const ValidationBudget = createAsyncThunk("ValidationBudget/ValidationBudget",
    async (parameters, { rejectWithValue }) => {
        try {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
                "api/Validation/ValidationBudget", parameters
            );
            // Extract data from the response object
            const data = response.data.result; // Assuming response has a "data" field

            return data; // Return the extracted data
        } catch(error) {
            return rejectWithValue(error.message);
        }
    }
)

const ValidationBudgetreducer = createSlice({
    name: "ValidationBudget",
    initialState: {
        ValidationBudgetList: [],
        lodingValidationBudgetList: false,
        errorValidationBudgetList: null,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(ValidationBudget.pending, (state, action) => {
                state.lodingValidationBudgetList = true;
                state.ValidationBudgetList = action.payload;
                state.errorValidationBudgetList = null;
            })
            .addCase(ValidationBudget.fulfilled, (state, action) => {
                state.lodingValidationBudgetList = false;
                state.ValidationBudgetList = action.payload; // Assuming payload has the desired data
            })
            .addCase(ValidationBudget.rejected, (state, action) => {
                state.lodingValidationBudgetList = false;
                state.addObjectivesActivities = action.payload;
            })
        
    }
})

export default ValidationBudgetreducer.reducer